module.exports = __webpack_public_path__ + "img/award-logo.8a142f36.png";